import ApiPermisos from './../../services/apiPermisos'
//import axios from "axios";


export default {
  namespaced: true,
  // state,
  // actions,
  // mutations,
  // getters
  state: {    
    demands: [],
    loading: false,
    errorMsj: '',
  },
  getters: {},
  mutations: {
    setDemands: (state, demands) => {
      state.demands = demands;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
  },
  actions: {
    /*
     *
     * ALL DEMANDS
     * 
     */
    actGetLicenses: async ({
      commit
      }, /*data*/) => {
        commit('setLoading', true); // Start loading
        let response = await ApiPermisos.GetLicenses();
        commit('setLoading', false); // End loading
        if (response.error) {
            return response.error;
        }
        commit('setDemands', response);
        
        return true;
    },

    //Trae la informacion de filtros avanzados getfilterAdv
    actGetfilterAdv: async ({ commit }, { data, query = {} }) => {
        //console.log(data);
        commit('setLoading', true); // Start loading
        let response = await ApiPermisos.GetLicensesAdv(data, query);
        commit('setLoading', false); // End loading
        /*if (response.error) {
            return response.error;
        }*/
        commit('setDemands', response);
        
        return true;
    },
  },
}